export enum NumberFormat {
  THOUSANDS_PENCE = '0,0.00',
  THOUSANDS = '0,0',
}
